import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-radius: 16px 0 0 16px;\n  color: #27262c;\n  padding: 12px;\n  position: absolute;\n  top: -25%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 50px 30px 10px 30px;\n  @media screen and (max-width: 575px) {\n    padding: 35px 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: 130px;\n  height: 36px;\n  padding: 8px 0px 11px 0px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n  background: #fff;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  border-radius: 18px;\n  background: #b2c7d1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  padding: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Text } from "../Text";
import { Button, IconButton } from "../Button";
import Flex from "../Box/Flex";
import { variants } from "./types";
var getThemeColor = function(param) {
    var theme = param.theme, _variant = param.variant, variant = _variant === void 0 ? variants.INFO : _variant;
    switch(variant){
        case variants.DANGER:
            return theme.colors.failure;
        case variants.WARNING:
            return theme.colors.warning;
        case variants.SUCCESS:
            return theme.colors.success;
        case variants.INFO:
        default:
            return theme.colors.secondary;
    }
};
var getTextColor = function() {
    var variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : variants.INFO;
    switch(variant){
        case variants.DANGER:
            return "#FA492C";
        case variants.WARNING:
            return "#FA492C";
        case variants.SUCCESS:
            return "#2DB7F5";
        case variants.INFO:
            return "#06D063";
        default:
            return "#06D063";
    }
};
var getIcon = function() {
    var variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : variants.INFO;
    switch(variant){
        case variants.DANGER:
            return "/images/core/IconAlert.svg";
        case variants.WARNING:
            return "/images/core/IconAlert.svg";
        case variants.SUCCESS:
            return "/images/core/IconSuccess.png";
        case variants.INFO:
            return "/images/core/IconInfo.png";
        default:
            return "/images/core/IconSuccess.png";
    }
};
var IconLabel = styled.div.withConfig({
    componentId: "sc-c59eb8f5-0"
})(_templateObject());
var withHandlerSpacing = 32 + 12 + 8; // button size + inner spacing + handler position
var Details = styled.div.withConfig({
    componentId: "sc-c59eb8f5-1"
})(_templateObject1());
var CloseHandler = styled(Button).withConfig({
    componentId: "sc-c59eb8f5-2"
})(_templateObject2());
var StyledAlert = styled(Flex).withConfig({
    componentId: "sc-c59eb8f5-3"
})(_templateObject3());
var Alert = function(param) {
    var title = param.title, children = param.children, variant = param.variant, onClick = param.onClick;
    return /*#__PURE__*/ _jsx(StyledAlert, {
        children: /*#__PURE__*/ _jsxs("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #FFF",
                width: "100%",
                height: "100%",
                flexDirection: "column",
                borderRadius: "18px"
            },
            children: [
                /*#__PURE__*/ _jsx(IconLabel, {
                    variant: variant,
                    hasDescription: !!children,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: getIcon(variant)
                    })
                }),
                /*#__PURE__*/ _jsxs(Details, {
                    hasHandler: !!onClick,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: {
                                color: getTextColor(variant),
                                fontWeight: "700",
                                fontSize: "22px"
                            },
                            bold: true,
                            children: title
                        }),
                        typeof children === "string" ? /*#__PURE__*/ _jsx(Text, {
                            style: {
                                textAlign: "center",
                                color: "#040810",
                                fontWeight: "400"
                            },
                            as: "p",
                            children: children
                        }) : children
                    ]
                }),
                onClick && /*#__PURE__*/ _jsx(CloseHandler, {
                    onClick: onClick,
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        scale: "sm",
                        variant: "text",
                        onClick: onClick,
                        children: "Close"
                    })
                })
            ]
        })
    });
};
export default Alert;
